
import { EDuration, type TProduct } from '../type'

import type { $Enums } from '@prisma/client'
import type { IEcommerce } from '@/hooks/analyticsData'

import { getCurrentPrice } from '@/contexts/PlanContext/helpers/getCurrentPrice'

export function getProductItems({
  productPriceList,
  appName,
}: {
  productPriceList: TProduct[]
  appName: $Enums.SubLogAppName
}) {
  const items = productPriceList

    .map((p) => {
      const priceInfo = getCurrentPrice({
        productPrice: p,
      })
      return {
        item_id: p.priceId,
        item_name: p.productName,
        quantity: 1,
        price: priceInfo.currencyPrice,
        item_category: appName,
        item_category2:
          p.duration === EDuration.MONTHLY ? 'Monthly' : 'Annually',
      }
    })
    .filter((item) => item.price > 0) as IEcommerce['items']
  return items
}
